import {
    ButtonGradientAi,
    FOCUS_RING,
    Icon,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

interface GenerateObjectiveAiButtonProps {
    disabled: boolean;
    onClick?: () => void;
}

/**
 * The "Générer avec l'IA" trigger beside the objective title card, with its sparkles icon. While
 * `disabled`, a "coming soon" tooltip explains a control that does nothing yet; once enabled the
 * tooltip is gone and `onClick` opens the generation window.
 */
export default function GenerateObjectiveAiButton({
    disabled,
    onClick,
}: GenerateObjectiveAiButtonProps) {
    const { t } = useTranslation();

    const button = (
        <ButtonGradientAi
            type={'button'}
            size={'sm'}
            disabled={disabled}
            onClick={onClick}
            leftIcon={
                <Icon
                    name={'support-magic-star'}
                    size={'sm'}
                    color={'inherit'}
                />
            }
            dataTestId={'objective-form-generate-ai'}
        >
            {t('objectives.form.generateWithAi')}
        </ButtonGradientAi>
    );

    if (!disabled) {
        return button;
    }

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    {/* A disabled button swallows pointer events -- same wrapping pattern as
                        `ContributorAvatars`: the tooltip listens on this focusable span instead. */}
                    <span
                        tabIndex={0}
                        className={`${FOCUS_RING} inline-block`}
                    >
                        {button}
                    </span>
                </TooltipTrigger>

                <TooltipContent side={'top'}>
                    {t('objectives.form.generateWithAiComingSoon')}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
